"use strict";
// Compulsory payment-line trigger rule (Fizzy #1581). A ticket payment line
// carries a percentage; the trigger says WHEN that slice is due. A line with a
// percentage but no trigger is the "partially eligible – payment terms
// unresolved" (false-yellow) data-entry gap the 13 Aug 2026 Rivonia drawdown
// meeting flagged. This is the single source of truth for the rule, shared by
// the frontend form schema and the backend write-path guard so both sides
// agree byte-for-byte.
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleTriggerIssues = scheduleTriggerIssues;
// `compulsory` is the TICKET_PAYMENT_TRIGGER_REQUIRED flag state.
//   true  → the #1581 rule: a line with percent > 0 must carry its trigger
//           (downpayment_trigger for the advance, trigger_event for tranches);
//           a 0% line is exempt (both kinds).
//   false → today's behaviour: every BL tranche needs trigger_event regardless
//           of percent, and the downpayment trigger is not checked at all.
function scheduleTriggerIssues(schedule, opts) {
    const issues = [];
    schedule.forEach((line, index) => {
        if (opts.compulsory) {
            if (line.percent <= 0)
                return;
            if (line.kind === 'Downpayment' && !line.downpayment_trigger) {
                issues.push({ index, field: 'downpayment_trigger' });
            }
            if (line.kind === 'BLTranche' && !line.trigger_event) {
                issues.push({ index, field: 'trigger_event' });
            }
            return;
        }
        if (line.kind === 'BLTranche' && !line.trigger_event) {
            issues.push({ index, field: 'trigger_event' });
        }
    });
    return issues;
}
//# sourceMappingURL=payment-schedule-triggers.js.map